import { createClient } from '@supabase/supabase-js';

// Public Supabase URL + publishable key — boleh exposed di client bundle (sb_publishable_*
// dimaksudkan untuk client-side). Kunci ini hanya role anon. Data dilindungi RLS: anon ditolak (SQL 06),
// hanya role horus_operator yang dibuka (SQL 05). Semua .from()/storage/realtime/rpc membawa JWT role itu,
// diterbitkan /api/auth-check setelah login HORUS dan disimpan di sessionStorage per tab (setDataToken).
// Hardcoded fallback supaya HF Space (yg gak inject VITE_* di build) tetap jalan.
const FALLBACK_URL = 'https://dbozfuvytuhdrayrlvjn.supabase.co';
const FALLBACK_KEY = 'sb_publishable_dPxhECX3kmUJN_1wxcb5RA_-ngvl4mj';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || FALLBACK_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY || FALLBACK_KEY;

const TOKEN_KEY = 'horus.sb.token';

// Opsi accessToken mematikan supabase.auth.* (melempar galat): aplikasi tidak memakai Supabase Auth.
export const supabase = createClient(supabaseUrl, supabaseKey, {
  accessToken: async () => sessionStorage.getItem(TOKEN_KEY),
});

// Dipanggil SecurityGate sesaat setelah login, sebelum aplikasi merender query dan channel pertama.
// realtime.setAuth() memaksa Realtime membaca token baru: klien dibuat sebelum login, saat token masih kosong.
export const setDataToken = (token) => {
  sessionStorage.setItem(TOKEN_KEY, token);
  return supabase.realtime.setAuth();
};
